import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  Mail,
  MessageCircle,
  BriefcaseBusiness,
  Camera,
  Building2,
} from "lucide-react";
import "./ContactUs.css";

export default function ContactUs() {
  const navigate = useNavigate();

  return (
    <div className="contact-page">

      {/* HEADER */}
      <header className="contact-header">
        <button
          className="contact-back"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ArrowLeft size={20} />
        </button>

        <div>
          <h1>Contact Us</h1>
          <p>We are here to help</p>
        </div>
      </header>

      <main>

        {/* HERO */}
        <section className="contact-hero">
          <div className="contact-hero-icon">
            <MessageCircle size={32} />
          </div>

          <div>
            <span>GET IN TOUCH</span>

            <h2>
              We'd love to hear
              <br />
              from you.
            </h2>

            <p>
              Have a question, suggestion, business enquiry,
              or need help with Civilink? Reach out to us.
            </p>
          </div>
        </section>

        {/* CONTACT OPTIONS */}
        <section className="contact-section">

          <div className="contact-section-title">
            <span>CONTACT</span>
            <h2>Connect with Civilink</h2>
          </div>

          <div className="contact-grid">

            <a
              href="mailto:civilink.official@gmail.com"
              className="contact-card"
            >
              <div className="contact-card-icon">
                <Mail size={22} />
              </div>

              <div>
                <h3>Email</h3>
                <p>
                  civilink.official@gmail.com
                </p>
                <small>
                  Send us your enquiry
                </small>
              </div>
            </a>

            <a
              href="https://www.instagram.com/civilink.official"
              target="_blank"
              rel="noreferrer"
              className="contact-card"
            >
              <div className="contact-card-icon">
                <Camera size={22} />
              </div>

              <div>
                <h3>Instagram</h3>
                <p>
                  @civilink.official
                </p>
                <small>
                  Follow Civilink
                </small>
              </div>
            </a>

            <a
              href="https://www.linkedin.com/company/civilink-private-limited/"
              target="_blank"
              rel="noreferrer"
              className="contact-card"
            >
              <div className="contact-card-icon">
                <BriefcaseBusiness size={22} />
              </div>

              <div>
                <h3>LinkedIn</h3>
                <p>
                  Civilink Private Limited
                </p>
                <small>
                  Connect with us professionally
                </small>
              </div>
            </a>

          </div>

        </section>

        {/* COMPANY */}
        <section className="contact-company">

          <Building2 size={26} />

          <div>
            <h3>Civilink Private Limited</h3>

            <p>
              Construction • Professionals • Property
            </p>

            <small>
              For business partnerships, vendor enquiries,
              professional services and platform support,
              contact the Civilink team.
            </small>
          </div>

        </section>

      </main>

    </div>
  );
}